// extracted by mini-css-extract-plugin
export default {"headerMenu":"headerMenu_headerMenu__GHu8V","link":"headerMenu_link__A+Z4h","active":"headerMenu_active__JtCAo headerMenu_link__A+Z4h"};